import request from '@/utils/request'

//获取库存列表
export function post(data) {
    return request({
        url: '',
        method: 'post',
        data
    })
}
//获取商品批次号 入库数量 剩余数量
export function get(data) {
    return request({
        url: '',
        method: 'post',
        data
    })
}